var DropSelect = require('sma.admin/components/dropdowns/dropselect');
var {Prompt} = require('sma.common/components/modals');
var ajax = require('sma.common/ajax');

/* pass in items as a list of objects like this:
 * {
 *     name: 'foo',
 *     text: 'foobar',
 *     checked: true
 * }
 * onDone is a callback that is passed the item list in the same format as above */
class DropSelectEditable extends DropSelect {
	get events () {
		var events = super.events;

		events['click .sma-js-dropselect-create-new'] = 'createNewItem';
		events['click .sma-js-dropselect-done'] = 'addLabels';
		
		return events;
	}

	initialize (options) {
		this.editable = true;
		this.createButton = options.createButton ?? true;
		this.noCancelButton = true;
		this.createUrl = options.createUrl;
		this.doneButtonSize = 'sm';
		this.doneCallback = options.doneCallback || null;
		this.createCallback = options.createCallback || null;
		this.dataType = options.dataType || 'json';
		this.name = options.name || '';
		this.localized = options.localized || false;
		this.language = options.language || '';
		super.initialize(options);
		if (this.localized) {
			if (!this.language && window.__EDIT_LANGUAGE) {
				this.language = window.__EDIT_LANGUAGE;
				this.getItems();
			}
			postal.subscribe({
				channel: "i18n",
				topic: "language.changed",
				callback: (data, envelope) => {
					this.languageChange(data.lang);
				}
			});
		}
	}

	languageChange(newLanguage) {
		this.language  = newLanguage;
		this.getItems();
	}

	adjustUrlForLanguage(url) {
		if (this.language !== '')
			if (url.includes('?'))
				url += '&lang_override=' + this.language;
			else
				url += '?lang_override=' + this.language;
		return url;
	}

	addLabels() {
		if (this.doneCallback) {
			this.doneCallback();
		}
		
		this.handleDone();
	}

	handleDone() {
		super.handleDone();
	}

	createNewItem () {
		var createItem = (value) => {
			var that = this;
			let url = this.adjustUrlForLanguage(this.createUrl);
			ajax.post({
				url: url,
				dataType: that.dataType,
				data: {'name': value },
				callback: data => {
					that.updateChangedItems();
					that.getItems();
					if (this.createCallback) {
						this.createCallback(data);
					}
				}
			});
		};

		let dlg = new Prompt(
			this.createButtonLabel || gettext('New'),
			this.name,
			createItem
		);

		let ok = dlg.modalFooter.find('.sma-js-notify-ok');
		ok.addClass('disabled');
		$('.sma-js-validate-input').on('input', function() {
			var value = dlg.modalBody.find('.sma-js-validate-input').val();
			ok.toggleClass('disabled', value.length === 0);
		});
	}
}

module.exports = DropSelectEditable;
